import { elgigantenContent } from "../brandContent/elgigantenBrandContent";
import BrandLogo from "/static/images/tenants/elgiganten/elgiganten.svg";
import { elgigantenMeta } from "../brandMetaData/elgigantenMetaData";
import { elgigantenPrize } from "../brandPrize/elgigantenPrize";
import { elgiganten } from "../brandThemes/elgiganten";

export const ELGIGANTEN_brandVariables = {
  tenantId: "elgiganten-nbxpa", // For picking wich leaderboard to show
  themeId: "elgiganten",
  gameStyle: "racing", // For picking wich leaderboard to show
  eventCode: "", // Optional, for fetching correct challenge
  gameType: "f12025", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  leaderboardLength: 7,
  disclaimer: null,

  brandLogo: BrandLogo,
  theme: elgiganten,
  metaInfo: elgigantenMeta,
  content: elgigantenContent,
  prize: elgigantenPrize,
};
